import { useQuery } from '@tanstack/react-query'
import { getDomainQuota } from '../../services'
import { AdminQueryKey } from '@/modules/admin/keys'
import { DomainQuotaResponse } from '@/modules/admin/type'

export default function useQueryGetDomainQuota(enabled: boolean = true) {
	return useQuery<DomainQuotaResponse>({
		queryKey: [AdminQueryKey.GetDomainQuota],
		queryFn: () => getDomainQuota(),
		enabled,
	})
}
